import * as React from 'react';

export const RegFormWidget = ({ id }) => {
  (async function () {
    const html = await fetch(`https://edu.advance24.online/reg_form/share/${id}?` + new URLSearchParams({
      layout: '',
      modal_toggle_text: '',
      modal_toggle_class_name: '',
    })).then(r => r.text())

    const currentScriptElement = document.querySelector(`script#widget_${id}`)

    if (!currentScriptElement) return

    const virtualDiv = document.createElement('div')
    const wrapper = document.createElement('div')

    virtualDiv.innerHTML = html

    while (virtualDiv.firstChild) {
      if (virtualDiv.firstChild.nodeName === '#comment') {
        virtualDiv.firstChild.remove()
        continue
      }

      if (
        virtualDiv.firstChild.nodeName === 'SCRIPT' &&
        virtualDiv.firstChild.classList[0] === 'executable'
      ) {
        const script = document.createElement('script')
        script.text = virtualDiv.firstChild.text
        wrapper.appendChild(script)
        virtualDiv.firstChild.remove()
      } else {
        wrapper.appendChild(virtualDiv.firstChild)
      }
    }

    currentScriptElement.replaceWith(...wrapper.children)
  })()
  return (
    <script id={`widget_${id}`}></script>
  );
};
